import React from 'react'
import logo from '../../../assets/static/logo-planalto2.png'

const LogotipoPlanaltoMenor = () => (
	<img 
	className="logotipo-planalto-menor" 
	src={logo} 
	alt="Logotipo Planalto"
	width="150px"
	height="30px"
	 />
)

export default LogotipoPlanaltoMenor
